"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plugins = exports.default = exports.components = exports.actions = void 0;
var _Accordion = _interopRequireDefault(require("./components/Accordion"));
var _ActivityCard = _interopRequireDefault(require("./components/ActivityCard"));
var _Architecture = _interopRequireDefault(require("./components/Architecture"));
var _AreaCard = _interopRequireDefault(require("./components/AreaCard"));
var _AudiovideoBanner = _interopRequireDefault(require("./components/AudiovideoBanner"));
var _Banner = _interopRequireDefault(require("./components/Banner"));
var _BannerContainer = _interopRequireDefault(require("./components/BannerContainer"));
var _BannerOffsetContainer = _interopRequireDefault(require("./components/BannerOffsetContainer"));
var _Benefits = _interopRequireDefault(require("./components/Benefits"));
var _BenefitsTab = _interopRequireDefault(require("./components/BenefitsTab"));
var _BottomBanner = _interopRequireDefault(require("./components/BottomBanner"));
var _BrandEquity = _interopRequireDefault(require("./components/BrandEquity"));
var _Button = _interopRequireDefault(require("./components/Button"));
var _BuyNowNew = _interopRequireDefault(require("./components/BuyNowNew"));
var _BuyProduct = _interopRequireDefault(require("./components/BuyProduct1"));
var _BuyProduct2 = _interopRequireDefault(require("./components/BuyProduct2"));
var _BuyProduct3 = _interopRequireDefault(require("./components/BuyProduct3"));
var _BuyProduct4 = _interopRequireDefault(require("./components/BuyProduct4"));
var _CertificationSystem = _interopRequireDefault(require("./components/CertificationSystem"));
var _CircleLogoText = _interopRequireDefault(require("./components/CircleLogoText"));
var _ClassifyTabContainer = _interopRequireDefault(require("./components/ClassifyTabContainer"));
var _Code = _interopRequireDefault(require("./components/Code"));
var _Contact = _interopRequireDefault(require("./components/Contact"));
var _CouponOMTwo = _interopRequireDefault(require("./components/CouponOMTwo"));
var _CustomComponent = _interopRequireDefault(require("./components/CustomComponent"));
var _DiscountPurchaseCard = _interopRequireDefault(require("./components/DiscountPurchaseCard"));
var _ExclusiveBenefits = _interopRequireDefault(require("./components/ExclusiveBenefits"));
var _Faq = _interopRequireDefault(require("./components/Faq"));
var _FlexCustomersTab = _interopRequireDefault(require("./components/FlexCustomersTab"));
var _FlexInternationalLogo = _interopRequireDefault(require("./components/FlexInternationalLogo"));
var _FlexNavigate = _interopRequireDefault(require("./components/FlexNavigate"));
var _FlexQuickStartsTab = _interopRequireDefault(require("./components/FlexQuickStartsTab"));
var _FlexTitle = _interopRequireDefault(require("./components/FlexTitle"));
var _FormTable = _interopRequireDefault(require("./components/FormTable"));
var _FreeWithBuyNowNew = _interopRequireDefault(require("./components/FreeWithBuyNowNew"));
var _FreeWithCardNew = _interopRequireDefault(require("./components/FreeWithCardNew"));
var _FreeWithCredit = _interopRequireDefault(require("./components/FreeWithCredit"));
var _FreeWithCreditIteration = _interopRequireDefault(require("./components/FreeWithCreditIteration"));
var _FunctionalComparison = _interopRequireDefault(require("./components/FunctionalComparison"));
var _GrowthPlan = _interopRequireDefault(require("./components/GrowthPlan"));
var _IconText = _interopRequireDefault(require("./components/IconText"));
var _LessonPlan = _interopRequireDefault(require("./components/LessonPlan"));
var _LogoText = _interopRequireDefault(require("./components/LogoText"));
var _MarketCard = _interopRequireDefault(require("./components/MarketCard"));
var _MenuContainer = _interopRequireDefault(require("./components/MenuContainer"));
var _MenuPanelContainer = _interopRequireDefault(require("./components/MenuPanelContainer"));
var _MultipleScenarios = _interopRequireDefault(require("./components/MultipleScenarios"));
var _NewBanner = _interopRequireDefault(require("./components/NewBanner"));
var _NewBannerWithInfo = _interopRequireDefault(require("./components/NewBannerWithInfo"));
var _Notice = _interopRequireDefault(require("./components/Notice"));
var _NumberCard = _interopRequireDefault(require("./components/NumberCard"));
var _Operate = _interopRequireDefault(require("./components/Operate"));
var _OverViewBanner = _interopRequireDefault(require("./components/OverViewBanner"));
var _PackageCard = _interopRequireDefault(require("./components/PackageCard"));
var _PackageSwitch = _interopRequireDefault(require("./components/PackageSwitch"));
var _Partner = _interopRequireDefault(require("./components/Partner"));
var _PdfView = _interopRequireDefault(require("./components/PdfView"));
var _PicText = _interopRequireDefault(require("./components/PicText"));
var _PriceSet = _interopRequireDefault(require("./components/PriceSet"));
var _PriceSetTab = _interopRequireDefault(require("./components/PriceSetTab"));
var _ProductCards = _interopRequireDefault(require("./components/ProductCards"));
var _ProductIntroduction = _interopRequireDefault(require("./components/ProductIntroduction"));
var _ProductResource = _interopRequireDefault(require("./components/ProductResource"));
var _ProductsService = _interopRequireDefault(require("./components/ProductsService"));
var _ProductsSpecific = _interopRequireDefault(require("./components/ProductsSpecific"));
var _PublishPrice = _interopRequireDefault(require("./components/PublishPrice"));
var _PublishPriceTab = _interopRequireDefault(require("./components/PublishPriceTab"));
var _Quickstarts = _interopRequireDefault(require("./components/Quickstarts"));
var _RecommendCard = _interopRequireDefault(require("./components/RecommendCard"));
var _RelatedProducts = _interopRequireDefault(require("./components/RelatedProducts"));
var _SMEFreeCard = _interopRequireDefault(require("./components/SMEFreeCard"));
var _SMEFreeTabCard = _interopRequireDefault(require("./components/SMEFreeTabCard"));
var _Scenarios = _interopRequireDefault(require("./components/Scenarios"));
var _ScenariosCard = _interopRequireDefault(require("./components/ScenariosCard"));
var _SceneChange = _interopRequireDefault(require("./components/SceneChange"));
var _SceneIntroduce = _interopRequireDefault(require("./components/SceneIntroduce"));
var _SceneTabs = _interopRequireDefault(require("./components/SceneTabs"));
var _SceneTabsHorizontal = _interopRequireDefault(require("./components/SceneTabsHorizontal"));
var _SceneTabsImageFull = _interopRequireDefault(require("./components/SceneTabsImageFull"));
var _SceneTabsRelevance = _interopRequireDefault(require("./components/SceneTabsRelevance"));
var _SelectCard = _interopRequireDefault(require("./components/SelectCard"));
var _SelectPaginationContainer = _interopRequireDefault(require("./components/SelectPaginationContainer"));
var _ShortBanner = _interopRequireDefault(require("./components/ShortBanner"));
var _SpecialOffers = _interopRequireDefault(require("./components/SpecialOffers"));
var _StoriesScenarios = _interopRequireDefault(require("./components/StoriesScenarios"));
var _StudentCenterBanner = _interopRequireDefault(require("./components/StudentCenterBanner"));
var _TceTable = _interopRequireDefault(require("./components/TceTable"));
var _TextUrl = _interopRequireDefault(require("./components/TextUrl"));
var _TpmActionPanelHalf = _interopRequireDefault(require("./components/TpmActionPanelHalf"));
var _TpmAdvantage = _interopRequireDefault(require("./components/TpmAdvantage"));
var _TpmAdvantageBanner = _interopRequireDefault(require("./components/TpmAdvantageBanner"));
var _TpmAdvantageText = _interopRequireDefault(require("./components/TpmAdvantageText"));
var _TpmAnchorWidget = _interopRequireDefault(require("./components/TpmAnchorWidget"));
var _TpmBanner = _interopRequireDefault(require("./components/TpmBanner"));
var _TpmBuyCardFull = _interopRequireDefault(require("./components/TpmBuyCardFull"));
var _TpmBuyCardGroup = _interopRequireDefault(require("./components/TpmBuyCardGroup"));
var _TpmBuyCardNormal = _interopRequireDefault(require("./components/TpmBuyCardNormal"));
var _TpmCase = _interopRequireDefault(require("./components/TpmCase"));
var _TpmCaseLayout = _interopRequireDefault(require("./components/TpmCaseLayout"));
var _TpmCertificate = _interopRequireDefault(require("./components/TpmCertificate"));
var _TpmCommonBanner = _interopRequireDefault(require("./components/TpmCommonBanner"));
var _TpmComparison = _interopRequireDefault(require("./components/TpmComparison"));
var _TpmDoc = _interopRequireDefault(require("./components/TpmDoc"));
var _TpmDocPanel = _interopRequireDefault(require("./components/TpmDocPanel"));
var _TpmDocument = _interopRequireDefault(require("./components/TpmDocument"));
var _TpmFAQ = _interopRequireDefault(require("./components/TpmFAQ"));
var _TpmFeature = _interopRequireDefault(require("./components/TpmFeature"));
var _TpmImage = _interopRequireDefault(require("./components/TpmImage"));
var _TpmIntroCard = _interopRequireDefault(require("./components/TpmIntroCard"));
var _TpmIntroCardAdvantage = _interopRequireDefault(require("./components/TpmIntroCardAdvantage"));
var _TpmIntroCardImage = _interopRequireDefault(require("./components/TpmIntroCardImage"));
var _TpmIntroCardLogo = _interopRequireDefault(require("./components/TpmIntroCardLogo"));
var _TpmIntroCardText = _interopRequireDefault(require("./components/TpmIntroCardText"));
var _TpmOperateArea = _interopRequireDefault(require("./components/TpmOperateArea"));
var _TpmOverview = _interopRequireDefault(require("./components/TpmOverview"));
var _TpmResource = _interopRequireDefault(require("./components/TpmResource"));
var _TpmScene = _interopRequireDefault(require("./components/TpmScene"));
var _TpmSceneHorizontal = _interopRequireDefault(require("./components/TpmSceneHorizontal"));
var _TpmSceneSell = _interopRequireDefault(require("./components/TpmSceneSell"));
var _TpmSceneSequence = _interopRequireDefault(require("./components/TpmSceneSequence"));
var _TpmSceneStagger = _interopRequireDefault(require("./components/TpmSceneStagger"));
var _TpmSceneVertical = _interopRequireDefault(require("./components/TpmSceneVertical"));
var _TpmSlognBanner = _interopRequireDefault(require("./components/TpmSlognBanner"));
var _TpmSolution = _interopRequireDefault(require("./components/TpmSolution"));
var _TpmStep = _interopRequireDefault(require("./components/TpmStep"));
var _TpmStepImageDynamic = _interopRequireDefault(require("./components/TpmStepImageDynamic"));
var _TpmStepImageStatic = _interopRequireDefault(require("./components/TpmStepImageStatic"));
var _TpmSubHero = _interopRequireDefault(require("./components/TpmSubHero"));
var _TpmTabFeature = _interopRequireDefault(require("./components/TpmTabFeature"));
var _TpmTable = _interopRequireDefault(require("./components/TpmTable"));
var _TpmTopNav = _interopRequireDefault(require("./components/TpmTopNav"));
var _TpmTransferFooter = _interopRequireDefault(require("./components/TpmTransferFooter"));
var _TpmTransferModule = _interopRequireDefault(require("./components/TpmTransferModule"));
var _TpmVideoCourse = _interopRequireDefault(require("./components/TpmVideoCourse"));
var _TpmVoucher = _interopRequireDefault(require("./components/TpmVoucher"));
var _TxtCard = _interopRequireDefault(require("./components/TxtCard"));
var _Whitepaper = _interopRequireDefault(require("./components/Whitepaper"));
var _BindUser = _interopRequireDefault(require("./plugins/BindUser"));
var _CheckLogin = _interopRequireDefault(require("./actions/CheckLogin"));
const components = exports.components = {
  Accordion: {
    component: _Accordion.default
  },
  ActivityCard: {
    component: _ActivityCard.default
  },
  Architecture: {
    component: _Architecture.default
  },
  AreaCard: {
    component: _AreaCard.default
  },
  AudiovideoBanner: {
    component: _AudiovideoBanner.default
  },
  Banner: {
    component: _Banner.default
  },
  BannerContainer: {
    component: _BannerContainer.default
  },
  BannerOffsetContainer: {
    component: _BannerOffsetContainer.default
  },
  Benefits: {
    component: _Benefits.default
  },
  BenefitsTab: {
    component: _BenefitsTab.default
  },
  BottomBanner: {
    component: _BottomBanner.default
  },
  BrandEquity: {
    component: _BrandEquity.default
  },
  Button: {
    component: _Button.default
  },
  BuyNowNew: {
    component: _BuyNowNew.default
  },
  BuyProduct1: {
    component: _BuyProduct.default
  },
  BuyProduct2: {
    component: _BuyProduct2.default
  },
  BuyProduct3: {
    component: _BuyProduct3.default
  },
  BuyProduct4: {
    component: _BuyProduct4.default
  },
  CertificationSystem: {
    component: _CertificationSystem.default
  },
  CircleLogoText: {
    component: _CircleLogoText.default
  },
  ClassifyTabContainer: {
    component: _ClassifyTabContainer.default
  },
  Code: {
    component: _Code.default
  },
  Contact: {
    component: _Contact.default
  },
  CouponOMTwo: {
    component: _CouponOMTwo.default
  },
  CustomComponent: {
    component: _CustomComponent.default
  },
  DiscountPurchaseCard: {
    component: _DiscountPurchaseCard.default
  },
  ExclusiveBenefits: {
    component: _ExclusiveBenefits.default
  },
  Faq: {
    component: _Faq.default
  },
  FlexCustomersTab: {
    component: _FlexCustomersTab.default
  },
  FlexInternationalLogo: {
    component: _FlexInternationalLogo.default
  },
  FlexNavigate: {
    component: _FlexNavigate.default
  },
  FlexQuickStartsTab: {
    component: _FlexQuickStartsTab.default
  },
  FlexTitle: {
    component: _FlexTitle.default
  },
  FormTable: {
    component: _FormTable.default
  },
  FreeWithBuyNowNew: {
    component: _FreeWithBuyNowNew.default
  },
  FreeWithCardNew: {
    component: _FreeWithCardNew.default
  },
  FreeWithCredit: {
    component: _FreeWithCredit.default
  },
  FreeWithCreditIteration: {
    component: _FreeWithCreditIteration.default
  },
  FunctionalComparison: {
    component: _FunctionalComparison.default
  },
  GrowthPlan: {
    component: _GrowthPlan.default
  },
  IconText: {
    component: _IconText.default
  },
  LessonPlan: {
    component: _LessonPlan.default
  },
  LogoText: {
    component: _LogoText.default
  },
  MarketCard: {
    component: _MarketCard.default
  },
  MenuContainer: {
    component: _MenuContainer.default
  },
  MenuPanelContainer: {
    component: _MenuPanelContainer.default
  },
  MultipleScenarios: {
    component: _MultipleScenarios.default
  },
  NewBanner: {
    component: _NewBanner.default
  },
  NewBannerWithInfo: {
    component: _NewBannerWithInfo.default
  },
  Notice: {
    component: _Notice.default
  },
  NumberCard: {
    component: _NumberCard.default
  },
  Operate: {
    component: _Operate.default
  },
  OverViewBanner: {
    component: _OverViewBanner.default
  },
  PackageCard: {
    component: _PackageCard.default
  },
  PackageSwitch: {
    component: _PackageSwitch.default
  },
  Partner: {
    component: _Partner.default
  },
  PdfView: {
    component: _PdfView.default
  },
  PicText: {
    component: _PicText.default
  },
  PriceSet: {
    component: _PriceSet.default
  },
  PriceSetTab: {
    component: _PriceSetTab.default
  },
  ProductCards: {
    component: _ProductCards.default
  },
  ProductIntroduction: {
    component: _ProductIntroduction.default
  },
  ProductResource: {
    component: _ProductResource.default
  },
  ProductsService: {
    component: _ProductsService.default
  },
  ProductsSpecific: {
    component: _ProductsSpecific.default
  },
  PublishPrice: {
    component: _PublishPrice.default
  },
  PublishPriceTab: {
    component: _PublishPriceTab.default
  },
  Quickstarts: {
    component: _Quickstarts.default
  },
  RecommendCard: {
    component: _RecommendCard.default
  },
  RelatedProducts: {
    component: _RelatedProducts.default
  },
  SMEFreeCard: {
    component: _SMEFreeCard.default
  },
  SMEFreeTabCard: {
    component: _SMEFreeTabCard.default
  },
  Scenarios: {
    component: _Scenarios.default
  },
  ScenariosCard: {
    component: _ScenariosCard.default
  },
  SceneChange: {
    component: _SceneChange.default
  },
  SceneIntroduce: {
    component: _SceneIntroduce.default
  },
  SceneTabs: {
    component: _SceneTabs.default
  },
  SceneTabsHorizontal: {
    component: _SceneTabsHorizontal.default
  },
  SceneTabsImageFull: {
    component: _SceneTabsImageFull.default
  },
  SceneTabsRelevance: {
    component: _SceneTabsRelevance.default
  },
  SelectCard: {
    component: _SelectCard.default
  },
  SelectPaginationContainer: {
    component: _SelectPaginationContainer.default
  },
  ShortBanner: {
    component: _ShortBanner.default
  },
  SpecialOffers: {
    component: _SpecialOffers.default
  },
  StoriesScenarios: {
    component: _StoriesScenarios.default
  },
  StudentCenterBanner: {
    component: _StudentCenterBanner.default
  },
  TceTable: {
    component: _TceTable.default
  },
  TextUrl: {
    component: _TextUrl.default
  },
  TpmActionPanelHalf: {
    component: _TpmActionPanelHalf.default
  },
  TpmAdvantage: {
    component: _TpmAdvantage.default
  },
  TpmAdvantageBanner: {
    component: _TpmAdvantageBanner.default
  },
  TpmAdvantageText: {
    component: _TpmAdvantageText.default
  },
  TpmAnchorWidget: {
    component: _TpmAnchorWidget.default
  },
  TpmBanner: {
    component: _TpmBanner.default
  },
  TpmBuyCardFull: {
    component: _TpmBuyCardFull.default
  },
  TpmBuyCardGroup: {
    component: _TpmBuyCardGroup.default
  },
  TpmBuyCardNormal: {
    component: _TpmBuyCardNormal.default
  },
  TpmCase: {
    component: _TpmCase.default
  },
  TpmCaseLayout: {
    component: _TpmCaseLayout.default
  },
  TpmCertificate: {
    component: _TpmCertificate.default
  },
  TpmCommonBanner: {
    component: _TpmCommonBanner.default
  },
  TpmComparison: {
    component: _TpmComparison.default
  },
  TpmDoc: {
    component: _TpmDoc.default
  },
  TpmDocPanel: {
    component: _TpmDocPanel.default
  },
  TpmDocument: {
    component: _TpmDocument.default
  },
  TpmFAQ: {
    component: _TpmFAQ.default
  },
  TpmFeature: {
    component: _TpmFeature.default
  },
  TpmImage: {
    component: _TpmImage.default
  },
  TpmIntroCard: {
    component: _TpmIntroCard.default
  },
  TpmIntroCardAdvantage: {
    component: _TpmIntroCardAdvantage.default
  },
  TpmIntroCardImage: {
    component: _TpmIntroCardImage.default
  },
  TpmIntroCardLogo: {
    component: _TpmIntroCardLogo.default
  },
  TpmIntroCardText: {
    component: _TpmIntroCardText.default
  },
  TpmOperateArea: {
    component: _TpmOperateArea.default
  },
  TpmOverview: {
    component: _TpmOverview.default
  },
  TpmResource: {
    component: _TpmResource.default
  },
  TpmScene: {
    component: _TpmScene.default
  },
  TpmSceneHorizontal: {
    component: _TpmSceneHorizontal.default
  },
  TpmSceneSell: {
    component: _TpmSceneSell.default
  },
  TpmSceneSequence: {
    component: _TpmSceneSequence.default
  },
  TpmSceneStagger: {
    component: _TpmSceneStagger.default
  },
  TpmSceneVertical: {
    component: _TpmSceneVertical.default
  },
  TpmSlognBanner: {
    component: _TpmSlognBanner.default
  },
  TpmSolution: {
    component: _TpmSolution.default
  },
  TpmStep: {
    component: _TpmStep.default
  },
  TpmStepImageDynamic: {
    component: _TpmStepImageDynamic.default
  },
  TpmStepImageStatic: {
    component: _TpmStepImageStatic.default
  },
  TpmSubHero: {
    component: _TpmSubHero.default
  },
  TpmTabFeature: {
    component: _TpmTabFeature.default
  },
  TpmTable: {
    component: _TpmTable.default
  },
  TpmTopNav: {
    component: _TpmTopNav.default
  },
  TpmTransferFooter: {
    component: _TpmTransferFooter.default
  },
  TpmTransferModule: {
    component: _TpmTransferModule.default
  },
  TpmVideoCourse: {
    component: _TpmVideoCourse.default
  },
  TpmVoucher: {
    component: _TpmVoucher.default
  },
  TxtCard: {
    component: _TxtCard.default
  },
  Whitepaper: {
    component: _Whitepaper.default
  }
};
const plugins = exports.plugins = {
  BindUser: {
    plugin: _BindUser.default
  }
};
const actions = exports.actions = {
  CheckLogin: {
    action: _CheckLogin.default
  }
};
var _default = exports.default = {
  components,
  plugins,
  actions
};